import { Api } from "@/common/api/Api";
import { axiosInstance } from "@/plugins/axios";
import AutocompleteApi from "@/common/api/AutocompleteApi";
import { LocationAutocompleteView } from "@/context/location/model/LocationAutocompleteView";
import { AxiosResponse } from "axios";
import { AxiosInstance } from "axios";

export class LocationApi extends Api {
  constructor(axios: AxiosInstance) {
    super("location", axios);
  }

  public static async findAutocomplete(
    search: string,
    query: string
  ): Promise<Array<LocationAutocompleteView>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete(
      "location",
      search,
      query
    );
    return response.data;
  }
}

export const locationApi = new LocationApi(axiosInstance);
